import { Quote } from "lucide-react";
import { useReveal } from "@/lib/useReveal";

const TESTIMONIALS = [
  {
    quote: "Cel mai natural spray tan pe care l-am avut vreodată. Absolut perfect!",
    name: "Andreea M.",
  },
  {
    quote: "Rezultat uniform și foarte elegant. M-am simțit ca într-un salon de lux.",
    name: "Bianca P.",
  },
  {
    quote: "Ador ideea cu stickerele, este super distractivă și arată incredibil!",
    name: "Iulia R.",
  },
];

export default function Testimonials() {
  const r = useReveal();
  return (
    <section
      id="testimoniale"
      data-testid="testimonials-section"
      className="py-24 sm:py-32 bg-[#FFFDF9]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div ref={r.ref} className={`max-w-2xl mb-14 ${r.className}`}>
          <div className="section-label mb-4">Testimoniale</div>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-[#3B2A22] leading-[1.05]">
            Ce spun <em className="italic text-[#B88746]">clientele noastre</em>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <Card t={t} i={i} key={t.name} />
          ))}
        </div>
      </div>
    </section>
  );
}

function Card({ t, i }) {
  const r = useReveal();
  return (
    <div
      ref={r.ref}
      className={r.className}
      style={{ transitionDelay: `${i * 80}ms` }}
      data-testid={`testimonial-${i}`}
    >
      <div className="tbb-card h-full flex flex-col gap-5">
        <Quote size={28} className="text-[#B88746]" strokeWidth={1.2} />
        <p className="font-serif text-xl text-[#3B2A22] italic leading-snug">
          “{t.quote}”
        </p>
        <div className="mt-auto pt-4 border-t border-[#D7B899]/40">
          <div className="font-medium text-[#3B2A22]" data-testid={`testimonial-name-${i}`}>
            {t.name}
          </div>
        </div>
      </div>
    </div>
  );
}
